// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const MoreHoriz: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 34 10" enableBackground="new 0 0 34 10" xmlSpace="preserve">
<g>
	<path d="M4.5,0.83C2.21,0.83,0.33,2.71,0.33,5S2.21,9.17,4.5,9.17c2.29,0,4.17-1.88,4.17-4.17S6.79,0.83,4.5,0.83z"/>
	<path d="M29.5,0.83c-2.29,0-4.17,1.88-4.17,4.17s1.88,4.17,4.17,4.17c2.29,0,4.17-1.88,4.17-4.17S31.79,0.83,29.5,0.83z"/>
	<path d="M17,0.83c-2.29,0-4.17,1.88-4.17,4.17S14.71,9.17,17,9.17c2.29,0,4.17-1.88,4.17-4.17S19.29,0.83,17,0.83z"/>
</g>
</svg>;
};

export default React.memo(MoreHoriz);
